import { useQuery } from "@tanstack/react-query";
import { useApi } from "~hooks/apiHooks/useApi";
import type { Customer, CustomerResponse } from "~types/customer";

const useFetchCustomers = () => {
  const request = useApi();

  return useQuery({
    queryKey: ["customers"],
    queryFn: (): Promise<Customer[]> => request<CustomerResponse>("user/customers").then((response) => response?.data || []),
    staleTime: 5 * 60 * 1000,
  });
};

export default useFetchCustomers;
